module.exports = __webpack_public_path__ + "static/img/v76DetailImg.9cd5349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v76DetailImg.png
// module id = usmK
// module chunks = 1